export const contextKeys = {
  me: [/^me\.?/],
  jwt: [/^jwt\.?/],
  locale: [/^locale\.?/],
  location: [/^document\.pathname\.?/, /^document\.query\.?/],
  params: [/^document\.params\.?/],
  constants: [/^constants\.?/],
  states: [/^states\.?/],
  expressions: [/^exp\.?/],
};
